<template>
  <div id="ComponentInventoryCreate" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <span class="page-title" id="itemHeader">View Warranty Registration</span>
          <!-- <span id="itemHeader" v-else>Add Component Transaction</span> -->
          <div class="btn-groups">
            <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackItemList">
              <i class="fp-back"> </i> Back
            </button>
            <button type="submit" class="btn btn-secondary" style="margin-right: 5px;" v-on:click.prevent="previewPage">
              <i class="fp-view"> </i> Preview
            </button>
          </div>
        </div>
        <div class="container-fluid">
          <div id="ev_part_inventory_detail" class="admin-page-content asset-view list-view">
            <section class="internal-container border-top-table-fl">
              <div class="form-row no-divider">
                <div class="col-md-6">
                  <div class="row form-group">
                    <label class="col">Dealer :</label>
                    <span class="col" v-if="dealer_id != null && dealer_id.text">{{ titleCase(dealer_id.text) }}</span>
                    <span class="col" v-else>-</span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Dealer Address :</label>
                    <span class="col">{{ titleCase(dealer_address) }}</span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Dealer {{state_province}} :</label>
                    <span class="col">{{ titleCase(dealer_state) }}</span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Dealer {{zip_postal}} :</label>
                    <span class="col">{{ titleCase(dealer_postcode) }}</span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Vehicle :</label>
                    <span class="col" v-if="vehicle_id != null && vehicle_id.text">{{ titleCase(vehicle_id.text) }}</span>
                    <span class="col" v-else>-</span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Year :</label>
                    <template>
                      <span class="col">{{ titleCase(year) }}</span>
                    </template>
                  </div>
                  <div class="row form-group">
                    <label class="col">Make:</label>
                    <template>
                      <span class="col">{{ titleCase(make) }}</span>
                    </template>
                  </div>
                  <div class="row form-group">
                    <label class="col">Model:</label>
                    <template>
                      <span class="col">{{ titleCase(model) }}</span>
                    </template>
                  </div>
                  <div class="row form-group">
                    <label class="col">Registration Number:</label>
                    <template>
                      <span class="col">{{ titleCase(registration_number) }}</span>
                    </template>
                  </div>
                  <div class="row form-group">
                    <label class="col">Delay Start:</label>
                    <span class="col">{{ delay_start }}</span>
                  </div>
                  <div class="row form-group" v-show="delay_start === 'Yes'">
                    <label class="col">Delay Start Reason:</label>
                    <span class="col">{{ delayStartReason }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row form-group">
                    <label class="col">Odometer:</label>
                    <span class="col">{{ odometer }}</span>
                  </div>

                  <div class="row form-group">
                    <label class="col">Date of Sale:</label>
                    <span class="col">{{ date_of_sale }}</span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Date in Service:</label>
                    <span class="col">{{ date_in_service }}</span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Customer:</label>
                    <span class="col" v-if="consumer_id != null && consumer_id.text">{{ consumer_id.text }}</span>
                    <span class="col" v-else>-</span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Customer Address:</label>
                    <span class="col">{{ consumer_address }}</span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Customer Phone:</label>
                    <span class="col">{{ consumer_phone }}</span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Customer Email:</label>
                    <span class="col">{{ consumer_email }}</span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Customer Contact Name:</label>
                    <span class="col">{{ consumer_contact_name }}</span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Customer Delivery Type:</label>
                    <span class="col" v-if="consumer_delivery_type != null && consumer_delivery_type.text">{{ consumer_delivery_type.text }}</span>
                    <span class="col" v-else>-</span>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div v-if="basicRows.length > 0" class="table-responsive-sm">
					<h5 class="color-darkblue font-semibold"> Coverage Details </h5>
					<table class="table table-sm table-bordered font-1">
					<thead>
						<tr class="table-primary">
							<th scope="col" class="w-25">Type</th>
							<th scope="col" class="w-25">Years</th>
							<th scope="col" class="w-25">{{distance_unit}}</th>
							<th scope="col" class="w-25">End Date</th>
							<!--<th scope="col">Action</th>-->
						</tr>
					</thead>
					<tbody>
						<tr v-for="(read, index) in basicRows" :key="index">
							<td>
								<label class="control-label" for="">{{read.warranty_type}}</label>
							</td>
							<td>
								<label class="control-label" for="">{{read.warranty_period}}</label>
							</td>
							<td>
								<label class="control-label" for="">{{read.warranty_miles}}</label>
							</td>
							<td>
								<label class="control-label" for="">{{read.end_date}}</label>
							</td>
							<!--<td class="text-center valign-middle">
								<template v-if="rows.length != 1">
									<a href="javascript:void(0)" v-on:click.prevent="removeElement(index);"> <i class="fp-remove"></i> </a>
								</template>
								<template v-else>
									<span class="close-row"> _ </span>
								</template>
							</td>-->
						</tr>
                    </tbody>
                  </table>
        </div>

        <!-- Extended Warranty -->
        <div v-if=" showExtendedWarranty && rows && rows.length > 0" class="table-responsive-sm">
                  <h5 class="color-darkblue font-semibold"> Ext Warranty Purchased </h5>
                  <table class="table table-sm table-bordered font-1">
                    <thead>
                      <tr class="table-primary">
                        <!--<th scope="col">Action</th>-->
                        <th scope="col" class="w-25">Type</th>
                        <th scope="col" class="w-25">Years</th>
                        <th scope="col" class="w-25">{{distance_unit}}</th>
                        <th scope="col" class="w-25">End Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(read, index) in rows" :key="index">

                        <td>
                          <label class="control-label" for="">{{ read.warranty_type }}</label>
                        </td>
                        <td>
                          <label class="control-label" for="">{{ read.warranty_period }}</label>
                        </td>
                        <td>
                          <label class="control-label" for="">{{ read.warranty_miles }}</label>
                        </td>
                        <td>
                          <label class="control-label" for="">{{ read.end_date }}</label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
        </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import { commonMixins } from '../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";
import { contractMixins } from '../mixins/contractMixins';

Vue.component("loading-content", LoadingContent);

export default {
  name: "VehicleRegistrationView",
  components: {
    appFooter: () => import('@/components/Footer')
  },
  metaInfo() {
    return { title: (this.$route.params.id > 0) ? "View Warranty Registration | " + process.env.COPYRIGHT_NAME : "View Warranty Registration | " + process.env.COPYRIGHT_NAME }
  },
  mixins: [commonMixins, contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    loading: false,
    isAdmin: false,
    dealer_id: '',
    dealer_address: '',
    vehicle_id: '',
    year: '',
    make: '',
    model: '',
    odometer: 0,
    date_of_sale: null,
    date_in_service: null,
    consumer_id: '',
    consumer_address: '',
    consumer_delivery_type: '',
    delay_start: '',
    registration_number: null,
		dropZonePreviewFiles: [],
    docArr: [],
    basicRows: [],
    rows: [],
    showExtendedWarranty: false,
    delayStartReason: "",
    consumer_contact_name: '',
    consumer_phone: '',
    consumer_email: '',
    dealer_state: '',
    dealer_postcode: '',
  }),
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  watch: {
    //check permission change
    permissions: function (permissions) {

      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == 'add_vehicle_registration' || permissions[i].name == 'ev_add_vehicle_registration') {
            self.cantAccessPage = true;
          }
        }
      }

    }
  },
  created: function () {

  },
  mounted: function () {
    var self = this;
    self.getPermissions();
    var path = window.location.pathname;
    var segments = path.split("/");

    if (segments[3]) {
      self.loadVehicleRegistration();
    }

    var userObj = JSON.parse(localStorage.getItem("user_obj"));
    if (userObj.roles[0].name == "admin") {
      self.isAdmin = true;
    } else {
      self.isAdmin = false;
    }
  },
  methods: {

    BackItemList() {
      var self = this;

      self.$router.push("/warrantyregistration/list");

    },
    previewPage(){
      var self = this;
      var path = window.location.pathname;
      var segments = path.split("/");
      self.$router.push("/warrantyregistration/preview/"+segments[3]);
    },

    loadVehicleRegistration() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/vehicleregistration/" + segments[3],
            type: "GET",
            headers: {
                'Accept': "application/json",
                "Access-Control-Allow-Origin": "*",
                "Authorization": "Bearer " + localStorage.getItem("tkn"),
                "Access-Control-Allow-Headers":
                "Origin, Content-Type, Authorization,X-Requested-With",
                "Cache-Control": "no-cache"
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.year = data.content.year;
                    self.make = data.content.make;
                    self.model = data.content.model;
                    self.odometer = data.content.odometer;
                    self.date_of_sale = data.content.date_of_sale;
                    self.registration_number = data.content.registration_number;
                    self.date_in_service = data.content.date_in_service;

                    if (data.filePath != "") {
								      self.dropZonePreviewFiles = data.filePath;
								      if (self.dropZonePreviewFiles.length > 0) {
									      self.loadFilesPreview();
								      }
							      }

                    if(data.content.vehicle_id != null){
                        var vehicleData = self.titleCase(data.content.vehicle_unit_no);
                        if(data.content.vtCode != null){
                            vehicleData += " | " + self.titleCase(data.content.vtCode);
                        }
                        // if(data.content.vName != null){
                        //     vehicleData += " | " + self.titleCase(data.content.vName);
                        // }
                        self.vehicle_id = {value: data.content.vehicle_id, text: vehicleData};
                        //self.assetInfo = vehicleData;

                    }else{
                        self.vehicle_id = null;
                    }

                    if(data.content.dealer_id != null){
                        var dlrData = self.titleCase(data.content.dealer_code);
                        if(data.content.dealer_name != null){
                            dlrData += " | " + self.titleCase(data.content.dealer_name);
                        }
                        self.dealer_id = {value: data.content.dealer_id, text: dlrData};
                        self.dealer_address = data.content.dealer_address;
                        self.dealer_postcode = data.content.dealer_postcode;
                        self.dealer_state = data.content.dealer_state;
                    }else{
                        self.dealer_id = null;
                        self.dealer_address = '';
                        // self.is_ext_warranty = 0;
                    }

                    if(data.content.consumer_id != null){
                        var dlrData = self.titleCase(data.content.consumer_code);
                        if(data.content.consumer_name != null){
                            dlrData += " | " + self.titleCase(data.content.consumer_name);
                        }
                        self.consumer_id = {value: data.content.consumer_id, text: dlrData};
                        self.consumer_address = data.content.consumer_address;
                        self.consumer_contact_name = data.content.consumer_contact_name;
                        self.consumer_phone = data.content.consumer_phone;
                        self.consumer_email = data.content.consumer_email;
                    }else{
                        self.consumer_id = null;
                        self.consumer_address = '';
                        self.consumer_contact_name = '';
                        self.consumer_phone = '';
                        self.consumer_email = '';
                    }

                    self.consumer_delivery_type = {value: data.content.consumer_delivery_type, text: self.capitalizeFirstLetters(data.content.consumer_delivery_type)};

                    self.delay_start = data.content.is_delay_start;
                    if(self.delay_start == 1){ // date of sale required only if Delay Start not marked
                        self.delay_start = "Yes";
                    }else{
                      self.delay_start = "No";
                    }
                    self.delayStartReason = data.content.delay_start_reason;

                    self.loadVehicleRegistrationCoverage();

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'vehicle-registration-load-by-id')
            }
        });
    },

    loadVehicleRegistrationCoverage() {
			var self = this;
			self.loading = true;


			var formData = new FormData();
			formData.append('is_ext_warranty', self.is_ext_warranty);
			//data: formData,

			$.ajax({
				url: process.env.ROOT_API + "/vehicleregistrationcoverage/" + self.vehicle_id.value,
				type: "POST",
				data: formData,
				headers: {
					"Accept": "application/json",
					"Access-Control-Allow-Origin": "*",
					"Authorization": "Bearer " + localStorage.getItem("tkn"),
					"Access-Control-Allow-Headers":
						"Origin, Content-Type, Authorization,X-Requested-With",
					"Cache-Control": "no-cache"
				},
				crossDomain: true,
				processData: false,
				contentType: false,
				dataType: "json",
				success: function (data) {
					self.loading = false;
					if (data.status == "success") {

						self.basicRows = data.content.basic;
						self.rows = data.content.extended;

						//Set Ext Warranty Checkbox default false
						if (self.rows.length) {
							for (var i = 0; i < self.rows.length; i++) {
								self.rows[i].ext_warranty = false;
							}
						}


					}
				},
				error: function (jqXHR, exception) {
					self.loading = false;
					self.generateStatusCodeMessage(jqXHR, false, 'vehicle-registration-load-by-id')
				}
			});
		},

    loadFilesPreview: function () {
			var self = this;
			self.docArr = [];
			self.validateDocs = [];
			if (self.dropZonePreviewFiles.length > 0) {
				for (var i = 0; i < self.dropZonePreviewFiles.length; i++) {
					var url = self.dropZonePreviewFiles[i].url;
					// get file path from url
					self.docArr.push(self.getFilePathFromUrl(self.dropZonePreviewFiles[i].url));
					self.validateDocs.push({
						file_name: self.dropZonePreviewFiles[i].display_name,
						extension: self.dropZonePreviewFiles[i].extension
					});
				}
			}
		},

    getFilePathFromUrl(value) {

      var path = "";
      var src = value.split('/');
      var file_name = src[src.length - 1];
      var orgPath = src[src.length - 2];
      path = orgPath + "/" + file_name;
      return path;

    },

    titleCase(str) {
      if (str == null) {
        return;
      } else {
        var value = str.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/VehicleRegistrationView.vue